module.exports = __webpack_public_path__ + "img/56.7.Chla.75fda85a.png";